module.exports = "<!-- ESTIMATE HEADER -->\n<div class=\"item-modal-header row mb-0\">\n  <div class=\"row left-align mb-0\">\n    <div class=\"col s12 break-words\">\n      <h5>{{ riskIndicator?.name }}</h5>\n    </div>\n  </div>\n  <div class=\"row left-align\">\n    <div\n      class=\"col s12 break-words\"\n      [innerHtml]=\"riskIndicator?.description\"\n    ></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/planning-poker-risk-indicator-header/planning-poker-risk-indicator-header.component.html
// module id = ../../../../../src/app/components/planning-poker-risk-indicator-header/planning-poker-risk-indicator-header.component.html
// module chunks = main